module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "boxch"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('strong', [_vm._v("Abbreviations")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_vm._v("ANF")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("The Ante-Nicene Fathers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_vm._v("BAGD")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("W. Bauer, W. F. Arndt, F. W. Gingrich, and F. W. Danker, "), _c('em', [_vm._v("A Greek-English Lexicon of the New Testament and Other Early Christian Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_vm._v("BDF")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("F. Blass, A. Debrunner, and R. W. Funk, "), _c('em', [_vm._v("A Greek Grammar of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("DB")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("James Hastings (ed.), "), _c('em', [_vm._v("Dictionary of the Bible")]), _vm._v(" (rev. by F. C. Grant and H. H. Rowley)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("ET")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Expository Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_vm._v("GNB")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Good News Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("IB")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Interpreter’s Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("IBD")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Illustrated Bible Dictionary")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("IDB")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Interpreter’s Dictionary of the Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("ISBE")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("International Standard Bible Encyclopedia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_vm._v("JB")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Jerusalem Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_vm._v("LB")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Living Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("The Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_vm._v("NEB")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New English Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("NIDNTT")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("New International Dictionary of New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New International Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("NovT")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Novum Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_vm._v("RSV")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_vm._v("SBk")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("H. Strack and P. Billerbeck, "), _c('em', [_vm._v("Kommentar zum Neuen Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("SE")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Studia Evangelica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left1"
  }, [_c('em', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Theological Dictionary of the New Testament")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccf7e7b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Abbre.vue
// module id = 72
// module chunks = 0